import { createStyles } from '@material-ui/core';
import { defaultFont } from '../../styles/style';

const style = createStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    ...defaultFont,
    fontSize: '20px',
    paddingBottom: 0,
  },
  title: {
    paddingLeft: '16px',
    paddingBottom: 0,
  },
});

export default style;
